import { axios } from "@Root/API";

export const putContactsAssociationForm = (contactId, data) => {
  return axios.put("association-detail", { ...data, id: contactId });
};
